module.exports = __webpack_public_path__ + "media/images/talent/results02-3a4bb9a48757973af39adf6542f03669.png";